import { firebaseAuth, firebase } from "config";
import message from "antd/lib/message";

export const login = async ({ email, password }) => {
  try {
    const response = await firebaseAuth.signInWithEmailAndPassword(
      email,
      password
    );

    return { error: false, response };
  } catch (error) {
    let description;
    switch (error.code) {
      case "auth/invalid-email":
        description = "Dirección de correo electrónico no es válida.";
        break;
      case "auth/user-disabled":
        description =
          "El usuario correspondiente al correo electrónico dado ha sido deshabilitado.";
        break;
      case "auth/user-not-found":
        description =
          "No hay ningún usuario correspondiente al correo electrónico dado.";
        break;
      default:
        // auth/wrong-password
        description =
          "La contraseña no es válida para el correo electrónico dado o si la cuenta correspondiente al correo electrónico no tiene una contraseña configurada.";
        break;
    }

    message.error(description);

    return { error: true, response: error };
  }
};

export const logout = async () => {
  const res = await firebaseAuth.signOut();
  return res;
};

export const resetPassword = async (email) => {
  try {
    const response = await firebaseAuth.sendPasswordResetEmail(email);
    return { error: false, response };
  } catch (error) {
    let description;

    switch (error.code) {
      case "auth/invalid-email":
        description = "Dirección de correo electrónico no es válida.";
        break;
      case "auth/missing-android-pkg-name":
        description =
          "Se debe proporcionar un nombre de paquete de Android si es necesario instalar la aplicación de Android.";
        break;
      case "auth/missing-continue-uri":
        description =
          "Se debe proporcionar una URL de continuación en la solicitud.";
        break;
      case "auth/missing-ios-bundle-id":
        description =
          "Se debe proporcionar un ID de paquete de iOS si se proporciona un ID de App Store.";
        break;
      case "auth/invalid-continue-uri":
        description =
          "La URL de continuación proporcionada en la solicitud no es válida.";
        break;
      case "auth/unauthorized-continue-uri":
        description =
          "El dominio de la URL de continuación no está incluido en la lista blanca. Incluya el dominio en la lista blanca en Firebase console.";
        break;
      default:
        // auth/user-not-found
        description =
          "No hay ningún usuario que corresponda a la dirección de correo electrónico.";
        break;
    }

    message.error(description);

    return { error: true, response: error };
  }
};

export const confirmResetPassword = async (code, newPassword) => {
  try {
    const res = await firebaseAuth.confirmPasswordReset(code, newPassword);
    return res;
  } catch (error) {
    let description;
    switch (error.code) {
      case "auth/expired-action-code":
        description =
          "El código de restablecimiento de contraseña ha expirado.";
        break;
      case "auth/invalid-action-code":
        description =
          "Código de restablecimiento de contraseña no es válido. Esto puede suceder si el código está mal formado o ya se ha utilizado.";
        break;
      case "auth/user-disabled":
        description =
          "Se lanza si el usuario correspondiente al código de restablecimiento de contraseña dado ha sido deshabilitado.";
        break;
      case "auth/user-not-found":
        description =
          "Usuario correspondiente al código de restablecimiento de contraseña. Esto puede haber sucedido si el usuario fue eliminado entre el momento en que se emitió el código y el momento en que se llamó a este método.";
        break;
      default:
        // auth/weak-password
        description = "La contraseña no es lo suficientemente segura.";
        break;
    }

    message.error(description);

    return { error: true, response: error };
  }
};

export const registerUser = async ({ email, password }) => {
  try {
    const client = await firebaseAuth.createUserWithEmailAndPassword(
      email,
      password
    );
    return client;
  } catch (error) {
    let description;
    switch (error.code) {
      case "auth/email-already-in-use":
        description =
          "Ya existe una cuenta con la dirección de correo electrónico proporcionada.";
        break;
      case "auth/invalid-email":
        description = "Dirección de correo electrónico no es válida.";
        break;
      case "auth/operation-not-allowed":
        description =
          "Habilite las cuentas de correo electrónico / contraseña en Firebase Console, en la pestaña Auth.";
        break;
      default:
        // auth/weak-password
        description = "La contraseña no es lo suficientemente segura.";
        break;
    }

    message.error(description);

    return { error: true, response: error };
  }
};

export const initializedRecaptcha = async () => {
  // required for method send code SMS

  try {
    window.recaptchaVerifier = await new firebase.auth.RecaptchaVerifier(
      "sign-in-button",
      {
        size: "invisible",
        callback: (response) => {
          // reCAPTCHA solved, allow signInWithPhoneNumber.
          // console.log("******RESPONSE********+");
          // console.log(response);
        },
      }
    );
  } catch (error) {
    console.log(error);
    if (window.grecaptcha) {
      await window.grecaptcha.reset();
    }

    if (window.recaptchaVerifier) {
      await window.recaptchaVerifier.clear();
    }
  }
};

const signWithPhone = (phoneNumber) => {
  const appVerifier = window.recaptchaVerifier;
  return firebaseAuth.signInWithPhoneNumber(phoneNumber, appVerifier);
};

export const sendCodeSMS = async (phoneNumber) => {
  try {
    const confirmationResult = await signWithPhone(phoneNumber);
    window.confirmationResult = confirmationResult;
    return { error: false, response: null };
  } catch (error) {
    return { error: true, response: error };
  }
};

export const verifyCodeSMS = async (code) => {
  try {
    const response = await window.confirmationResult.confirm(code);
    console.log(response);
    return { error: false, response };
  } catch (error) {
    console.log(error);
    return { error: true, response: error };
  }
};
